












































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { ImageFile } from '@/types/image'
import dayjs from 'dayjs'
import API from '@/api/types'
import { StateChanger } from 'vue-infinite-loading'

@Component({
  filters: {
    formatDate: (datetime: string) => {
      return dayjs(datetime).format('YYYY/MM/DD')
    },
    formatTime: (datetime: string) => {
      return dayjs(datetime).format('HH:mm')
    }
  },
  components: {
    Modal: () => import('@/components/common/modals/Modal.vue'),
    InfiniteLoading: () => import('vue-infinite-loading'),
    Loading: () => import('@/components/common/loadings/Index.vue'),
    SyncImage: () => import('@/components/imageTab/SyncImage.vue')
  }
})
export default class ImageList extends Vue {
  @Prop(Number) patientId!: number
  @Prop(String) patientName!: string
  @Prop({ default: 'image' }) type!: 'image' | 'dicom'

  $store!: ExStore
  thumbnailUrls: {
    [id: number]: string
  } = {}
  selectedItems: number[] = []

  @Emit('insert')
  insert() {
    return this.selectedItems
  }

  get items() {
    const key = this.isImage ? 'image/images' : 'dicom/dicoms'
    return this.$store.getters[key]
  }

  get isImage() {
    return this.type === 'image'
  }

  get hasNext() {
    const key = this.isImage ? 'image/hasImageNext' : 'dicom/hasDicomNext'
    return this.$store.getters[key]
  }

  async created() {
    await this.getItems()
  }

  async getItems() {
    const key = this.isImage ? 'image/updateImages' : 'dicom/updateDicoms'
    this.$store.dispatch(key, {
      patientId: this.patientId
    })
  }

  handleChangeSelect(e: Event, itemId: number) {
    if ((e.target as HTMLInputElement).checked) {
      this.selectedItems = [
        itemId,
        ...this.selectedItems.filter(id => id !== itemId)
      ]
    } else {
      this.selectedItems = this.selectedItems.filter(id => id !== itemId)
    }
  }

  getSenderName(item: ImageFile) {
    if (item.worker) {
      return `${item.worker.lastName}${item.worker.occupation.name}`
    }
    return this.patientName
  }

  getThumbnailUrl(itemId: number) {
    return this.thumbnailUrls[itemId] || ''
  }

  async handleThumbnailCreated(itemId: number) {
    if (itemId in this.thumbnailUrls) return
    const res =
      this.type === 'image'
        ? await this.$api[this.type].fetchThumbnail({
            patientId: this.patientId,
            imageId: itemId
          })
        : await this.$api[this.type].fetchThumbnail({
            patientId: this.patientId,
            dicomId: itemId
          })
    const url = window.URL.createObjectURL(res)
    this.thumbnailUrls = { ...this.thumbnailUrls, [itemId]: url }
  }

  handleNextLoad($state: StateChanger) {
    const key = this.isImage ? 'image/loadNextImages' : 'dicom/loadNextDicoms'
    this.$store
      .dispatch(key, {
        patientId: this.patientId
      })
      .then(() => {
        if (this.hasNext) {
          $state.loaded()
        } else {
          $state.complete()
        }
      })
  }
}
